import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

type SubMenus = "LINKS" | "GUEST_ACCESSES" | "PEOPLE_INVOLVED" | "KPI_DASHBOARD";
export const projectSubMenuConfig = {
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "PROJECT_OVERVIEW")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;
    const config = [
      {
        label: <MenuItemWithBadge label={`Project info`} />,
        link: "info",
      },
      {
        label: <MenuItemWithBadge label={`Links`} />,
        link: "links",
      },
    ];

    if (subModules) {
      subModules.includes("GUEST_ACCESSES") &&
        config.splice(1, 0, {
          label: <MenuItemWithBadge label={`Guest accesses`} />,
          link: "guest-accesses",
        });
      subModules.includes("PEOPLE_INVOLVED") &&
        config.splice(1, 0, {
          label: <MenuItemWithBadge label={`Project participants`} />,
          link: "members",
        });
      subModules.includes("KPI_DASHBOARD") &&
        config.splice(1, 0, {
          label: <MenuItemWithBadge label={`KPI Dashboard`} />,
          link: "kpi-dashboard",
        });
    }

    return config;
  },
};

export default projectSubMenuConfig;
